import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
export default function (props, context) {
    function scopeComponent1() {
        var component = props.component;
        return React.createElement('div', { 'className': 'main_class' }, '\r\n    ', React.cloneElement(component, {
            className: classNames(props.componentClassName, component.props.className),
            scrollContainer: props.scrollContainer
        }), '\r\n');
    }
    return scopeComponent1.apply(this, []);
}